import 'element-closest'; // polyfill for closest IE11
import 'ios-inner-height'; // window.innerHeight bug mobile Safari
import 'picturefill'; // polyfill for sourceset IE11
import 'promise-polyfill/src/polyfill'; // polyfill for promise IE11
import 'smoothscroll'; // polyfill for smooth scroll Edge - IE11
import 'classlist.js';

import '../../../../../../vendor/kunstmaan/cookie-bundle/bin/';
import forEach from './forEach';
import modals from './Modals';
import InvoiceFormSubscriber from './InvoiceFormSubscriber';
import WorkBookFormSubscriber from './WorkBookFormSubscriber';
import LoginFormContentReset from './LoginFormContentReset';
import LoginFormSubscriber from './LoginFormSubscriber';
import NewsletterSubscriber from './NewsletterSubscriber';
import sendExercise from './SendExercise';
import requestPasswordSubscriber from './RequestPasswordSubscriber';
import ProgressOverview from './ProgressOverview';
import PromoCodeFormSubscriber from './PromoCodeFormSubscriber';
import RatingFormSubscriber from './RatingFormSubscriber';
import totop from './totop';
import Toggle from './Toggle';
import initVideolink from './Videolink';
import initAnchorLinks from './initAnchorlinks';
import Popups from './Popups';
import initDataLayers from './dataLayers';
import audioplayer from './audioplayer';
import './arrayFromPolyfill';

document.addEventListener('DOMContentLoaded', () => {
    forEach();
    modals();
    Popups();
    new InvoiceFormSubscriber();
    new WorkBookFormSubscriber();
    new LoginFormContentReset();
    new LoginFormSubscriber();
    new NewsletterSubscriber();
    sendExercise();
    requestPasswordSubscriber();
    new ProgressOverview();
    new PromoCodeFormSubscriber();
    new RatingFormSubscriber();
    new Toggle();
    totop();
    initVideolink();
    initAnchorLinks();
    initDataLayers();
    audioplayer();
});



// WEBPACK FOOTER //
// ./src/Will/WebsiteBundle/Resources/ui/js/app.js